import { TabPageDefinition } from '@/components/tab-pages.js';

type AvailableTabs =
  | 'Today sessions'
  | 'Future sessions'
  | 'Student feedbacks'
  | 'Past sessions'
  | 'Sub sessions'
  | 'Overlapping sessions';

export const sessionsTabs = (selectedTab?: AvailableTabs): TabPageDefinition[] => {
  return [
    {
      label: "Today's sessions",
      linkProps: {
        to: '/sessions',
      },
      isSelectedTab: selectedTab === 'Today sessions' || !selectedTab, // Default to 'Today sessions' if no tab is selected
      dataTestId: 'sessions-tab-today',
    },
    {
      label: 'Future sessions',
      linkProps: {
        to: '/sessions/future',
      },
      isSelectedTab: selectedTab === 'Future sessions',
      dataTestId: 'sessions-tab-future',
    },
    {
      label: 'Past sessions',
      linkProps: {
        to: '/sessions/past',
      },
      isSelectedTab: selectedTab === 'Past sessions',
      dataTestId: 'sessions-tab-past',
    },
    {
      label: 'Sub sessions',
      linkProps: {
        to: '/sessions/sub-sessions',
      },
      isSelectedTab: selectedTab === 'Sub sessions',
      dataTestId: 'sessions-tab-sub',
    },
    {
      label: 'Overlapping sessions',
      linkProps: {
        to: '/sessions/overlapping',
      },
      isSelectedTab: selectedTab === 'Overlapping sessions',
      dataTestId: 'sessions-tab-overlapping',
    },
    {
      label: 'Student feedback',
      linkProps: {
        to: '/sessions/session-feedbacks',
      },
      isSelectedTab: selectedTab === 'Student feedbacks',
      dataTestId: 'sessions-tab-student-feedback',
    },
  ];
};
